import { RouteSegments } from '@cbridge-packages/routing-client-admin';

export const SETTINGS_PATHNAME = `${RouteSegments.Root.Config}/${RouteSegments.Config.Settings}`;
